import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';

const AffiliateRegister = () => {
    const [formData, setFormData] = useState({ full_name: '', email: '', phone: '', password: '' });
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${import.meta.env.VITE_API_URL}/affiliate/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            const data = await res.json();
            if (res.ok) {
                alert("Account created! Please login.");
                navigate('/affiliate/login');
            } else {
                alert(data.message);
            }
        } catch (error) { alert("Error registering"); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white">
            <div className="bg-gray-800 p-8 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center text-blue-400">Join Partner Program</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <input className="w-full p-3 bg-gray-700 rounded border border-gray-600 focus:border-blue-500 outline-none" placeholder="Full Name" onChange={e => setFormData({...formData, full_name: e.target.value})} required />
                    <input className="w-full p-3 bg-gray-700 rounded border border-gray-600 focus:border-blue-500 outline-none" type="email" placeholder="Email Address" onChange={e => setFormData({...formData, email: e.target.value})} required />
                    <input className="w-full p-3 bg-gray-700 rounded border border-gray-600 focus:border-blue-500 outline-none" placeholder="Phone Number" onChange={e => setFormData({...formData, phone: e.target.value})} required />
                    <input className="w-full p-3 bg-gray-700 rounded border border-gray-600 focus:border-blue-500 outline-none" type="password" placeholder="Password" onChange={e => setFormData({...formData, password: e.target.value})} required />
                    <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 p-3 rounded font-bold transition">Register</button>
                </form>
                <div className="mt-4 text-center text-sm text-gray-400">
                    Already a partner? <Link to="/affiliate/login" className="text-blue-400 hover:underline">Login here</Link>
                </div>
            </div>
        </div>
    );
};
export default AffiliateRegister;